import type { EditControlProps } from '../../declare'
import { Input } from 'antd'

const TextInput = (props: EditControlProps) => {
  const handleChange = (evt: any) => {
    props.onChange?.(evt.target.value)
  }

  const { __READONLY__, EDITABLE, PROMPT_INFO } = props.config
  return (
    <Input
      disabled={__READONLY__ || !EDITABLE}
      placeholder={PROMPT_INFO}
      value={props.value}
      onChange={handleChange}
    />
  )
}

export default TextInput